import React, { useMemo, useState } from 'react';
import { useUser } from '../../../../redux/reducer/user';
import { useRequestsHandlerData } from '../../../../hooks/useRequestsHandlerData';
import AppLoader from '../../../features/appLoader/AppLoader';
import classNames from 'classnames';
import useServiceData from '../../../../hooks/useServiceData';
import { rulesContent } from '../../../../constants/copyright';
import { defaultStore, useTranslation } from '../../../../translations';
import RulesImage from '../rulesImage/RulesImage';
import RulesHeader from '../rulesHeader/RulesHeader';
import RulesCarousel from '../rulesCarousel/RulesCarousel';
import RulesFooter from '../rulesFooter/RulesFooter';
import { useActions } from '../../../../hooks/components/pages/rules/useActions';
import getAvailableEvents from '../../../../constants/events';
import { useRequests } from '../../../../redux/reducer/requests';

const { list, mod } = rulesContent;

const Rules = React.forwardRef(function ({ isModal, closeModal }, ref) {
  const {
    authData: { isWeb },
  } = useRequests();
  const { isFirstEntry } = useUser();
  const [activeSlide, setActiveSlide] = useState(0);
  const { get } = useServiceData();

  const { t } = useTranslation();

  const rulesList = useMemo(() => {
    const availableEvents = getAvailableEvents(defaultStore);

    const filteredList = list(t).reduce((acc, rule) => {
      const { event } = rule;
      if (!event || availableEvents.includes(event)) acc.push(rule);
      return acc;
    }, []);

    if (isModal || isFirstEntry) return filteredList;

    const modalsData = get('modalsData') ?? {};

    return filteredList.filter((slide) => slide?.event && !modalsData?.[slide?.event]);
  }, []);

  const actions = useActions({ rulesList, activeSlide, setActiveSlide, isModal });

  const { type, img, picture, bg, buttonText, modType } = rulesList?.[activeSlide] ?? {};

  const isPending = useRequestsHandlerData([{ address: 'requestsUserSetActiveRoom', fulfilled: actions.changeState }]);

  return (
    <section
      className={classNames('rules', {
        [`rules_${type}`]: type,
        [`rules_${modType}`]: modType,
        [`rules_${mod}`]: mod,
        rules_app: !isWeb,
      })}
      ref={ref}
    >
      <RulesHeader isModal={isModal} closeModal={closeModal} />

      <RulesImage activeSlide={activeSlide} bg={bg} img={img} picture={picture} type={type} />

      <div className={'rules__content'}>
        <RulesCarousel activeSlide={activeSlide} setActiveSlide={setActiveSlide} rulesList={rulesList} />

        <RulesFooter
          isModal={isModal}
          closeModal={closeModal}
          setActiveSlide={setActiveSlide}
          activeSlide={activeSlide}
          buttonText={buttonText}
          changeState={actions.changeState}
          rulesList={rulesList}
        />
      </div>

      {isPending && <AppLoader />}
    </section>
  );
});
export default Rules;
Rules.propTypes = {};
